import { useState, useEffect } from "react";

export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Espera X ms después del último cambio
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cancela el timeout si el valor cambia antes de que se cumpla el delay
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
